import type { HTMLProps } from 'react';
import { forwardRef, useEffect, useState } from 'react';

import { Collapsible } from '@tripleten/design-system/collapsible';

import type { InputProps } from 'src/shared/components/input/input.js';
import { Input } from 'src/shared/components/input/input.js';
import type { PasswordStrengthMeterProps } from 'src/shared/components/password-strength-meter/password-strength-meter.js';
import { PasswordStrengthMeter } from 'src/shared/components/password-strength-meter/password-strength-meter.js';

import './password-input.css';

export type PasswordInputProps = InputProps & PasswordStrengthMeterProps;

export const PasswordInput = forwardRef<HTMLInputElement, HTMLProps<HTMLInputElement> & PasswordInputProps>((props) => {
    const {
        password,
        strengthLevels,
        onChange,
        onFocus,
        label,
        errorMessage,
        hintText,
        id = 'password',
        name = 'password',
    } = props;

    const [hidePasswordStrength, setHidePasswordStrength] = useState(true);

    useEffect(() => {
        if (password.length > 0 && hidePasswordStrength) {
            setHidePasswordStrength(false);
        }
    }, [hidePasswordStrength, password]);

    const inputErrorMessage = hidePasswordStrength ? errorMessage : '';

    return (
        <>
            <Input
                type="password"
                id={id}
                name={name}
                label={label}
                errorMessage={inputErrorMessage}
                onFocus={onFocus}
                onChange={onChange}
                value={password}
            />
            <Input type="hidden" id="password-confirm" name="password-confirm" value={password} />

            <Collapsible open={!hidePasswordStrength}>
                <Collapsible.Panel>
                    <PasswordStrengthMeter
                        className="password-input__strength-meter"
                        password={password}
                        hintText={hintText}
                        strengthLevels={strengthLevels}
                    />
                </Collapsible.Panel>
            </Collapsible>
        </>
    );
});
